import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/arrowLeft.svg'
import _imports_1 from '@/assets/icons/svg/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-1942c427"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full w-full relative" }
const _hoisted_2 = { class: "absolute top-0 left-0 z-10 w-full" }
const _hoisted_3 = {
  key: 0,
  class: "relative flex flex-row justify-between"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_0,
  alt: "back"
}, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_1,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_6 = {
  key: 2,
  class: "w-full h-full relative flex flex-row justify-center items-center",
  style: {"background-color":"#1953b9"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Your browser does not support HTML5 video. ")
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.mode !== $setup.MODES.places && $setup.mode !== $setup.MODES.playQuizz)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($setup.mode !== $setup.MODES.intro && $setup.mode !== $setup.MODES.finalDiscussion && $setup.mode !== $setup.MODES.finished)
              ? (_openBlock(), _createBlock($setup["Button"], {
                  key: 0,
                  class: "pointer-events-auto ml-6 bg-white m-6",
                  childclass: 'w-12 h-12',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.back()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($setup.mode === $setup.MODES.intro)
              ? (_openBlock(), _createBlock($setup["Button"], {
                  key: 1,
                  class: "pointer-events-auto ml-6 bg-white m-6",
                  childclass: 'w-12 h-12',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.finish()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("div\n          class=\"flex flex-row\"\n          v-if=\"mode !== MODES.finalDiscussion && mode !== MODES.discussion && mode !== MODES.movie && mode !== MODES.quizzResults\"\n        >\n          <Avatar v-for=\"p in players\" :key=\"p._id\" :layout=\"p.profile.avatar\" class=\"w-24 h-24\" />\n        </div")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        ($setup.mode === $setup.MODES.intro)
          ? (_openBlock(), _createBlock($setup["Intro"], {
              key: 0,
              title: $setup.t('title'),
              description: $setup.t('description'),
              "exercise-index": $setup.exerciseIndex,
              image: $setup.omarWithGlassesImage
            }, {
              default: _withCtx(() => [
                _createVNode($setup["Button"], {
                  backgroundcolour: 'bg-sl-green-button',
                  textcolour: 'text-white',
                  childclass: 'text-2xl border-none h-16 w-56',
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeMode($setup.MODES.firstInstruction)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('getStarted')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "description", "exercise-index", "image"]))
          : ($setup.mode === $setup.MODES.firstInstruction)
            ? (_openBlock(), _createBlock($setup["Instruction"], {
                key: 1,
                onPlaysound: $setup.playFirstInstruction,
                onStopsound: _cache[4] || (_cache[4] = ($event: any) => ($setup.stopSounds()))
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["Button"], {
                    backgroundcolour: 'bg-sl-green-button',
                    textcolour: 'text-white',
                    childclass: 'text-2xl border-none h-16 w-56',
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeMode($setup.MODES.movie)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : ($setup.mode === $setup.MODES.movie)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  ($setup.question.video)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        ref: "videoPlayer",
                        class: "w-full h-full",
                        preload: "autoplay",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.togglePlayPause()))
                      }, [
                        _createElementVNode("source", {
                          src: `${$setup.question.video + '#'}t=0.001`,
                          type: 'video/mp4'
                        }, null, 8 /* PROPS */, _hoisted_7),
                        _hoisted_8
                      ], 512 /* NEED_PATCH */))
                    : _createCommentVNode("v-if", true),
                  (!$setup.videoIsPlaying && $setup.question.video)
                    ? (_openBlock(), _createBlock($setup["RecordButton"], {
                        key: 1,
                        class: "absolute",
                        transparent: true,
                        "recording-exists": true,
                        onVclick: _cache[6] || (_cache[6] = ($event: any) => ($setup.togglePlayPause()))
                      }))
                    : _createCommentVNode("v-if", true),
                  ($setup.question.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        src: $setup.question.image,
                        class: "w-full h-full"
                      }, null, 8 /* PROPS */, _hoisted_9))
                    : _createCommentVNode("v-if", true),
                  _createVNode($setup["Button"], {
                    class: "absolute mb-3 bottom-2",
                    backgroundcolour: 'bg-sl-green-button',
                    textcolour: 'text-white',
                    childclass: 'text-2xl border-none h-16 w-56',
                    onClick: _cache[7] || (_cache[7] = 
            () => {
              $setup.togglePlayPause()
              $setup.changeMode($setup.MODES.discussion)
            }
          )
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : ($setup.mode === $setup.MODES.discussion || $setup.mode === $setup.MODES.finalDiscussion)
                ? (_openBlock(), _createBlock($setup["DiscussionTime"], {
                    key: 3,
                    question: $setup.question,
                    mode: $setup.mode,
                    round: $setup.meningRound,
                    results: $setup.results[$setup.meningRound]
                  }, {
                    default: _withCtx(() => [
                      ($setup.mode === $setup.MODES.discussion)
                        ? (_openBlock(), _createBlock($setup["Button"], {
                            key: 0,
                            backgroundcolour: 'bg-sl-green-button',
                            textcolour: 'text-white',
                            childclass: 'text-2xl border-none px-5 py-2',
                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.changeMode($setup.MODES.recording)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : ($setup.mode === $setup.MODES.finalDiscussion)
                          ? (_openBlock(), _createBlock($setup["Button"], {
                              key: 1,
                              backgroundcolour: 'bg-sl-green-button',
                              textcolour: 'text-white',
                              childclass: 'text-2xl border-none px-5 py-2',
                              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.changeMode($setup.MODES.endRound)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["question", "mode", "round", "results"]))
                : ($setup.mode === $setup.MODES.recording)
                  ? (_openBlock(), _createBlock($setup["VoiceRecording"], {
                      key: 4,
                      question: $setup.question,
                      sett: $setup.selectedSet,
                      onDone: _cache[10] || (_cache[10] = ($event: any) => ($setup.changeMode($setup.MODES.secondInstruction)))
                    }, null, 8 /* PROPS */, ["question", "sett"]))
                  : ($setup.mode === $setup.MODES.secondInstruction)
                    ? (_openBlock(), _createBlock($setup["Instruction"], {
                        key: 5,
                        onPlaysound: $setup.playSecondInstruction,
                        onStopsound: _cache[12] || (_cache[12] = ($event: any) => ($setup.stopSounds()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["Button"], {
                            backgroundcolour: 'bg-sl-green-button',
                            textcolour: 'text-white',
                            childclass: 'text-2xl border-none h-16 w-56',
                            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.changeMode($setup.MODES.quizzInstruction)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : ($setup.mode === $setup.MODES.quizzInstruction)
                      ? (_openBlock(), _createBlock($setup["Carousel"], {
                          key: 6,
                          class: "h-full"
                        }, {
                          addons: _withCtx(() => [
                            _createVNode($setup["CarouselTrigger"], {
                              ref: "carouselTriggerRef",
                              onNewPage: _cache[14] || (_cache[14] = 
                (index) => {
                  $setup.stopSounds()
                  $setup.playSounds([$setup.instructionPages[index].audio])
                }
              )
                            }, null, 512 /* NEED_PATCH */)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.instructionPages, (page, index) => {
                              return (_openBlock(), _createBlock($setup["Slide"], {
                                key: `page-${index}`,
                                index: index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode($setup["Instruction"], {
                                    image: page.image,
                                    "image-height": page.imageHeight,
                                    "speaker-top": page.speakerTop,
                                    "speaker-right": page.speakerRight,
                                    onPlaysound: ($event: any) => ($setup.playSounds([page.audio]))
                                  }, {
                                    pagination: _withCtx(() => [
                                      _createVNode($setup["Pagination"], { class: "my-12" })
                                    ]),
                                    default: _withCtx(() => [
                                      (index + 1 === $setup.instructionPages.length)
                                        ? (_openBlock(), _createBlock($setup["Button"], {
                                            key: 0,
                                            backgroundcolour: 'bg-sl-green-button',
                                            textcolour: 'text-white',
                                            childclass: 'text-2xl border-none h-16 w-56',
                                            onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.changeMode($setup.MODES.places)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                          }))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["image", "image-height", "speaker-top", "speaker-right", "onPlaysound"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : ($setup.mode === $setup.MODES.places)
                        ? (_openBlock(), _createBlock($setup["FindPlaces"], {
                            key: 7,
                            question: $setup.question,
                            onDone: $setup.resultsReady,
                            onPlaysound: $setup.playPlacesSound
                          }, {
                            default: _withCtx(() => [
                              _createVNode($setup["Button"], {
                                backgroundcolour: 'bg-sl-green-button',
                                textcolour: 'text-white',
                                childclass: 'text-2xl border-none px-5 py-2',
                                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.changeMode($setup.MODES.playQuizz)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.savedState ? $setup.t('back') : $setup.t('next')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["question"]))
                        : ($setup.mode === $setup.MODES.playQuizz)
                          ? (_openBlock(), _createBlock($setup["Quizz4Way"], {
                              key: 8,
                              question: $setup.question,
                              round: $setup.meningRound,
                              onDone: $setup.resultsReady,
                              onPlaysound: $setup.playOmarMening,
                              onReview: $setup.reviewMode
                            }, null, 8 /* PROPS */, ["question", "round"]))
                          : ($setup.mode === $setup.MODES.quizzResults)
                            ? (_openBlock(), _createBlock($setup["QuizzResults"], {
                                key: 9,
                                results: $setup.results[$setup.meningRound],
                                "omar-was-correct": $setup.question.mening[$setup.meningRound].statementCorrect
                              }, {
                                default: _withCtx(() => [
                                  _createVNode($setup["Button"], {
                                    backgroundcolour: 'bg-white',
                                    textcolour: 'text-black',
                                    childclass: 'text-2xl border-none px-5 py-4',
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.reviewMode($setup.MODES.movie)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('seeAgain')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode($setup["Button"], {
                                    class: "ml-4",
                                    backgroundcolour: 'bg-sl-green-button',
                                    textcolour: 'text-white',
                                    childclass: 'text-2xl border-none px-5 py-4',
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.changeMode($setup.MODES.finalDiscussion)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["results", "omar-was-correct"]))
                            : ($setup.mode === $setup.MODES.finished)
                              ? (_openBlock(), _createBlock($setup["Intro"], {
                                  key: 10,
                                  title: $setup.t('titleFinished'),
                                  description: $setup.t('descriptionFinished'),
                                  image: $setup.enigImage2
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode($setup["Button"], {
                                      backgroundcolour: 'bg-sl-green-button',
                                      textcolour: 'text-white',
                                      childclass: 'text-2xl border-none h-16 w-56',
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.finish()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('done')), 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title", "description", "image"]))
                              : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}